import { CircularProgressWithLabel } from '../../../../shared/components';

import { useCookingClock } from './useCookingClock';

import { TurboClock } from '../turbo-clock';

import type { CookingClockProps } from './CookingClock.domain';

export function CookingClock(props: CookingClockProps) {
  const { isTurboqueue } = props;
  const { label, value, statusTime } = useCookingClock(props);
  return isTurboqueue ? (
    <TurboClock label={label} />
  ) : (
    <CircularProgressWithLabel
      label={label}
      value={value}
      statusTime={statusTime}
    />
  );
}
